export enum TipoEstadoRancho {
    Pendiente = 0,
    Aprobado = 3,
    Desactivado = 4,
    Anulado = 5
}